<template lang="pug">
  v-dialog(v-model='dialog' scrollable persistent max-width='90%')
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        v-toolbar-title.headline {{ formTitle }}
      v-card-text
        v-row(dense)
          v-flex(xs12='xs12')
            template
              v-stepper(v-model='e6')
                v-stepper-header
                  v-stepper-step( :complete="e6 > 1" step="1") Información básica
                  v-divider
                  v-stepper-step(step="2") Información comercial
                  //v-divider
                    v-stepper-step(step="3" v-if='config.representante1 && config.representante1.valor') Representante
                v-stepper-items
                  v-stepper-content(step='1')
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-text
                          v-row(dense)
                            v-col(cols='12' xs='12' sm='6' md='6')#nombreC
                              v-text-field( v-model='form.nombre', hint="Requerido", persistent-hint, outlined, :readonly='read', id="nombreCom", label='Nombre Comercial', dense, v-uppercase)
                            v-col(cols='12' xs='12' sm='6' md='6' class='d-flex justify-center')
                              div(class="d-flex justify-space-around")
                                div(class="pa-0 mr-2" style="width:70px")
                                  v-select(v-model='rifLetra' :items='items' outlined dense :readonly='read' )
                                div(class="pa-0")#rifC
                                  v-text-field#rifCliente(v-model='rifNumerico' hint="Requerido" persistent-hint :readonly='read' label='Rif' outlined dense v-mask="'#########'")
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-subtitle.title(style='color: black') Información de Contacto
                        v-card-text
                          v-row(dense)
                            v-col(cols='12' xs='12' sm='4' md='2')
                              v-autocomplete(autocomplete="off", v-model='numCodigoCli' :items='itemsNum' outlined dense :readonly='read' )
                            v-col(cols='12' xs='12' sm='8' md='2')#tlfC
                              v-text-field(v-model='digitos' type='number' v-mask="'#######'" id='digitos' :readonly='read' label='Teléfono' outlined dense)
                            v-col(cols='12' xs='12' sm='6' md='4')#correoC
                              v-text-field#correoCliente(v-model='form.correo' :readonly='read'  label='Correo' outlined dense)
                            v-col(cols='12' xs='12' sm='12' md='4')#telefonosC
                              v-combobox#telefonosCliente(dense outlined :readonly='read' type='number' min='0' hint="Type el teléfono y presione Enter" v-model='form.telefonos' :items='telefonosTask' label='Teléfonos' multiple='' chips='')
                          v-row(dense)
                            v-col(cols='12' xs='12' sm='12' md='12')#direccionC
                              v-textarea#direccionCliente(auto-grow, v-model='form.direccion', :readonly='read', label="Dirección", outlined, dense, v-uppercase)
                    v-col(cols='12' v-if='(config.contribuyente && config.contribuyente.valor) || (config.idTipoCliente && config.idTipoCliente.valor) || (config.campoDiasCreditoCli && config.campoDiasCreditoCli.valor) || (config.campoLimCreditoCli && config.campoLimCreditoCli.valor)')
                      v-card(color='white')
                        v-card-subtitle.title(style='color: black') Tipo de Cliente
                        v-card-text
                          v-row(dense v-if='(config.contribuyente && config.contribuyente.valor) || (config.idTipoCliente && config.idTipoCliente.valor)')
                            v-col(cols='12' xs='12' sm='12' md='6' v-if='config.contribuyente && config.contribuyente.valor')#contriC
                              v-select#contribuyenteCliente(v-model='form.contribuyente' :readonly='read'  label='Contribuyente' :items='ContribuyenteArray' outlined dense)
                            v-col(cols='12' xs='12' sm='12' md='6' v-if="editedIndex === -1")#tipoC
                              v-autocomplete#tipoC(v-if='config.idTipoCliente && config.idTipoCliente.valor' autocomplete="off" :menu-props="{closeOnContentClick: true}" v-model='form.idTipoCliente' :readonly='read'  label='Tipo' :items='idTipoArray' outlined dense)
                                template(v-slot:prepend-item v-if="validarCrearCli()")
                                  v-list(dense)
                                    v-list-item( @click='tipoc = true')
                                      v-list-item-avatar(color='grey_1')
                                        v-btn.mx-2(fab dark x-small color='success')
                                          v-icon(dark small) mdi-plus
                                      v-list-item-content
                                        v-list-item-title
                                          | Agregar Tipo de Cliente
                              TipoClienteM(:dialog='tipoc' :editedIndex='-1' @close='tipoc = false' @save='listarTipo')
                            v-col(cols='12' xs='12' sm='12' md='6' v-else)#tipoC
                              v-text-field#tipoC(v-if='config.idTipoCliente && config.idTipoCliente.valor' v-model='form.idTipoCliente.descripcion' :readonly='read' label='Tipo' outlined dense)
                          v-row(dense v-if='(config.campoDiasCreditoCli && config.campoDiasCreditoCli.valor) || (config.campoLimCreditoCli && config.campoLimCreditoCli.valor)')
                            v-col(cols='12' xs='12' sm='12' md='6' v-if='config.campoLimCreditoCli && config.campoLimCreditoCli.valor' )#limiteC
                              v-text-field#limiteCredito( v-model.number='form.limiteCredito' type='number' min="0" :readonly='read' label='Limite de Credito' outlined dense)
                            v-col(cols='12' xs='12' sm='12' md='6')#diasC
                              v-text-field#diasCredito(v-if='config.campoDiasCreditoCli && config.campoDiasCreditoCli.valor' v-model.number='form.diasCredito' type='number' min="0" :readonly='read' label='Días de Credito' outlined dense)
                          v-row(dense v-if="mostrar")
                            v-col(cols='12' sm='12' md='1' v-if="editedIndex === -1 || read === false " class='d-flex justify-end')
                              v-switch.shrink.mr-2.mt-0(v-model='enabled' hide-details color='primary')
                            v-col(cols='12' sm='12' md='5' class='d-flex justify-end')#codigoC
                              v-text-field#codigoSunagro( v-model='form.codigoSunagro' type='number' :disabled='!enabled' min="0" :readonly='read' label='Codigo Sunagro' outlined dense v-mask="'######'")
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-subtitle.title(style='color: black') Ubicación Geográfica
                        v-card-text
                          v-row(dense v-if="editedIndex === -1")
                            v-col(cols='12' xs='12' sm='12' md='3')
                              v-select#estadoCliente(v-model='selecEstado' :readonly='read'  label='Estado' :items='idEstadoArray' @change='changeEstado' outlined dense)
                            v-col(cols='12' xs='12' sm='6' md='3')#correoC
                              v-text-field(v-model='form.ciudad' :readonly='read' label='Ciudad' outlined dense)
                            v-col(cols='12' xs='12' sm='12' md='3')
                              v-select#municipioCliente(v-model='selecMunicipio' :readonly='read'  label='Municipio' :items='arrayMunicipioEstado' @change='changeMunicipio' outlined dense)
                            v-col(cols='12' xs='12' sm='12' md='3')
                              v-select#parriquiaCliente(v-model='form.codParroquia' :readonly='read'  label='Parroquia' :items='arrayParroquiaMunicipio' outlined dense)
                          v-row(v-else)
                            v-col(cols='12' xs='12' sm='12' md='3')
                              v-select#estadoCliente(v-model='form.codEstado._id' :readonly='read'  label='Estado' :items='idEstadoArray' @change='changeEstado' outlined dense)
                            v-col(cols='12' xs='12' sm='6' md='3')#correoC
                              v-text-field(v-model='form.ciudad' :readonly='read' label='Ciudad' outlined dense)
                            v-col(cols='12' xs='12' sm='12' md='3')
                              v-select#municipioCliente(v-model='form.codMunicipio._id' :readonly='read'  label='Municipio' :items='arrayMunicipioEstado' @change='changeMunicipio' outlined dense)
                            v-col(cols='12' xs='12' sm='12' md='3')
                              v-select#parriquiaCliente(v-model='form.codParroquia._id' :readonly='read'  label='Parroquia' :items='arrayParroquiaMunicipio' outlined dense)
                          v-row(dense)
                            gmap-map(:center="center", :zoom="9", style="width:100%;  height: 400px;", @click='agregarMarker')
                              gmap-marker(:position="marker.position" :clickable="true")
                          p
                          v-row(dense)
                            v-col(cols='12' xs='12' sm='12' md='6')#laC
                              v-text-field( disabled, v-model='form.lat', outlined, dense, label='Latitud')
                            v-col(cols='12' xs='12' sm='12' md='6')#lonC
                              v-text-field( disabled, v-model='form.lng', outlined, dense, label='Longitud')
                    v-btn(color='success' dark @click='validarSteps()')
                      span Continuar
                  v-stepper-content(step='2')
                    v-col(cols='12' v-if='config.idRuta && config.idRuta.valor')
                      v-card(color='white')
                        v-card-subtitle.title(style='color: black') Ruta Comercial
                        v-card-text
                          v-row(dense class='d-flex justify-center')
                            v-col(cols='12' xs='12' sm='12' md='4' v-if="editedIndex === -1 && (config.idRuta && config.idRuta.valor)")#rutaC
                              v-select#rutaCliente(v-model='form.idRuta' outlined :readonly='read' label='Ruta' :items='idRutaArray' dense @change="changeRuta")
                            v-col(cols='12' xs='12' sm='12' md='4' v-else-if="config.idRuta && config.idRuta.valor")#rutaC
                              v-select#rutaCliente(v-model='form.idRuta._id' outlined :readonly='read' label='Ruta' :items='idRutaArray' dense)
                            // v-col(cols='12' xs='12' sm='12' md='6')#atencionC
                              v-select#tipoA(v-if="config.atencion && config.atencion.valor" v-model='form.atencion' :readonly='read'  label='Tipo de atencion' :items='AtencionArray' outlined dense)
                    v-col(cols='12' v-if='config.canal && config.canal.valor' )
                      v-card(color='white')
                        v-card-subtitle.title(style='color: black') Segmentación
                        v-card-text
                          v-row(dense)
                            v-col(cols='12' xs='12' sm='12' md='6')#canalC
                              v-select#canalCliente(v-model='form.canal' :readonly='read' label='Canal' :items='CanalArray' outlined dense)
                            v-col(cols='12' xs='12' sm='12' md='6')#subCanalC
                              v-autocomplete#subCanalCliente(autocomplete="off", v-model='form.subcanal' :items='SubCanalArray' :readonly='read'  label='Sub-Canal' outlined dense)
                    // v-col(cols='12' v-if='(config.diasVisitas && config.diasVisitas.valor) || (config.frecuencia && config.frecuencia.valor)')
                      v-card(color='white')
                        v-card-subtitle.title(style='color: black') Planificación
                        v-card-text
                          v-row(dense)
                            v-col(cols='12' xs='12' sm='12' md='6' v-if='config.diasVisitas && config.diasVisitas.valor')#diasC
                              v-select#diaC(v-model='form.diasVisitas' :readonly='read' label='Días de visita' :items='DiasArray' dense outlined multiple)
                            v-col(cols='12' xs='12' sm='12' md='6')#frecuenciaC
                              v-select#frecuenciaCliente(v-if='config.frecuencia && config.frecuencia.valor' v-model='form.frecuencia' :readonly='read'  label='Frecuencia de visita' :items='FrecuenciaArray' dense outlined)
                    v-btn(color='error' dark @click='e6 = 1' class="mr-5") Atras
                    v-btn(v-if="!read" color='success' dark @click='validarSteps()')
                      v-icon mdi-content-save
                      | Guardar
                  // v-stepper-content(step='3')
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-subtitle.title(style='color: black') Información de representantes
                        v-card-text
                          v-row(dense)
                            v-col(cols='12' xs='12' sm='12' md='6')#repre1
                              v-text-field#ref1( v-model='form.representante1', :readonly='read', label='Representante 1', outlined, dense, v-uppercase)
                            v-col(cols='12' xs='12' sm='12' md='6')#repre2
                              v-text-field#ref2( v-model='form.representante2', :readonly='read', label='Representante 2', outlined, dense, v-uppercase)
                          v-row(dense)
                            v-col(cols='12' xs='12' sm='12' md='6')#correo1
                              v-text-field#correo1(v-model='form.correo1' :readonly='read'  label='Correo 1' outlined dense)
                            v-col(cols='12' xs='12' sm='12' md='6')#correo2
                              v-text-field#correo2(v-model='form.correo2' :readonly='read'  label='Correo 2' outlined dense)
                          v-row(dense)
                            v-col(cols='12' xs='12' sm='12' md='6')#tlf1
                              v-text-field#telefono1(v-model='form.telefono1' :readonly='read'  label='Teléfono 1' v-mask="'(####)###-##-##'" outlined dense)
                            v-col(cols='12' xs='12' sm='12' md='6')#tlf2
                              v-text-field#telefono2(v-model='form.telefono2' :readonly='read'  label='Teléfono 2' v-mask="'(####)###-##-##'" outlined dense)
                    v-btn(color='error' dark @click='e6 = 2' class="mr-5") Atras
                    v-btn(v-if="!read" color='success' dark @click='validarSteps()')
                      v-icon mdi-content-save
                      | Guardar
      v-card-actions
        v-spacer
        v-btn(color='error' small dark @click='close')
          v-icon mdi-close
          | Cancelar
</template>

<script>
import Api from '@/services/methods'
import TipoClienteM from './TipoClienteM'
// import '../../assets/scss/estilosCliente.scss'
export default {
  props: ['dialog', 'editedIndex', 'FormPadre', 'read', 'mostrar'],
  name: 'ClienteM',
  data: () => ({
    center: { lat: 10.050485140418482, lng: -69.28207985600403 },
    marker: { position: null },
    enabled: false,
    config: null,
    tipoc: false,
    selecEstado: '',
    selecMunicipio: '',
    selecRuta: '',
    e6: 1,
    estado: [],
    idEstadoArray: [],
    municipio: [],
    idMunicipioArray: [],
    parroquia: [],
    idParroquiaArray: [],
    arrayMunicipioEstado: [],
    arrayParroquiaMunicipio: [],
    tipo: [],
    ruta: [],
    idRutaArray: [],
    idTipoArray: [],
    rifNumerico: '',
    rifLetra: 'V',
    numCodigoCli: '0424',
    digitos: '',
    telefonosTask: [],
    form: {
      nombre: '',
      rif: '',
      codigoSunagro: '',
      direccion: '',
      telefonos: [],
      telefono: '',
      idRuta: '',
      contribuyente: '',
      idTipoCliente: '',
      canal: '',
      subcanal: '',
      // atencion: '',
      codEstado: '',
      ciudad: '',
      codMunicipio: '',
      codParroquia: '',
      correo: '',
      // representante1: '',
      // representante2: '',
      // correo1: '',
      // correo2: '',
      // telefono1: '',
      // telefono2: '',
      // diasVisitas: '',
      // frecuencia: '',
      limiteCredito: null,
      diasCredito: null,
      lat: '',
      lng: ''
    },
    defaultItem: {
      nombre: '',
      rif: '',
      codigoSunagro: '',
      direccion: '',
      telefonos: [],
      telefono: '',
      idRuta: '',
      contribuyente: '',
      idTipoCliente: '',
      canal: '',
      subcanal: '',
      // atencion: '',
      codEstado: '',
      ciudad: '',
      codMunicipio: '',
      codParroquia: '',
      correo: '',
      // representante1: '',
      // representante2: '',
      // correo1: '',
      // correo2: '',
      // telefono1: '',
      // telefono2: '',
      // diasVisitas: '',
      // frecuencia: '',
      limiteCredito: null,
      diasCredito: null,
      lat: '',
      lng: ''
    },
    ContribuyenteArray: [
      'Especial',
      'Ordinario'
      // 'VERDADERO',
      // 'FALSO'
    ],
    // DiasArray: ['Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes'],

    /* FrecuenciaArray: [ 'Semana 1', 'Semana 2', 'Semana 3', 'Semana 4', 'Semana 1,2', 'Semana 1,3', 'Semana 1,4', 'Semana 2,3', 'Semana 2,4',
      'Semana 3,4', 'Semana 1,2,3', 'Semana 1,2,4', 'Semana 1,3,4', 'Semana 2,3,4', 'Semana 1,2,3,4'
    ], */
    CanalArray: [
      'Detal',
      'Mayorista',
      'Distribuidor',
      'Moderno',
      'Mayor',
      'Moderno',
      'Tradicional(Detal)'
    ],
    SubCanalArray: [
      'Abasto',
      'Bodega',
      'Bodegon',
      'Cadena',
      'Charcuteria',
      'Famarcia',
      'Frigorifico',
      'Hipermercado',
      'Panaderia',
      'Panificadora',
      'Supermercado',
      'Bienes y Servicios',
      'Comercial',
      'Ferretero',
      'Industrial',
      'Uniformes',
      'Otro'
    ],
    // AtencionArray: ['Pre-venta', 'Auto-venta'],
    items: ['V', 'E', 'J', 'P', 'G', 'C'],

    itemsNum: [
      '0412',
      '0414',
      '0424',
      '0416',
      '0426',
      '0248',
      '0281',
      '0282',
      '0283',
      '0285',
      '0292',
      '0240',
      '0247',
      '0278',
      '0243',
      '0244',
      '0246',
      '0273',
      '0278',
      '0284',
      '0285',
      '0286',
      '0288',
      '0289',
      '0241',
      '0242',
      '0243',
      '0245',
      '0249',
      '0258',
      '0287',
      '0212',
      '0259',
      '0268',
      '0269',
      '0279',
      '0235',
      '0238',
      '0246',
      '0247',
      '0251',
      '0252',
      '0253',
      '0271',
      '0274',
      '0275',
      '0212',
      '0234',
      '0239',
      '0287',
      '0291',
      '0292',
      '0295',
      '0255',
      '0256',
      '0257',
      '0272',
      '0293',
      '0294',
      '0275',
      '0276',
      '0277',
      '0278',
      '0271',
      '0272',
      '0212',
      '0251',
      '0253',
      '0254',
      '0261',
      '0262',
      '0263',
      '0264',
      '0265',
      '0266',
      '0267',
      '0271',
      '0275'
    ],

    permisosCli: {}
  }),

  components: {
    TipoClienteM
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Nuevo Cliente'
        : this.read
          ? 'Información del Cliente'
          : 'Modificar Cliente'
    }
  },
  watch: {
    FormPadre (val) {
      if (val.idRuta) {
        this.selecRuta = val.idRuta._id
      }
      // formulario que llega del padre, para editar y ver
      if (Object.keys(val).length !== 0) {
        this.form = Object.assign({}, this.defaultItem)
        this.formDefault(val, this.form)
        this.desconcatenarRif(val.rif)
        this.desconcatenarNum(val.telefono)
        if (this.form.lat && this.form.lng) {
          this.center.lat = this.form.lat
          this.center.lng = this.form.lng
        }
        this.e6 = 1
        if (
          this.form.codEstado !== '' &&
          this.form.codMunicipio !== '' &&
          this.form.codParroquia !== ''
        ) {
          this.changeEstado(val.codEstado._id)
          this.changeMunicipio(val.codMunicipio._id)
          this.changeParroquia(val.codParroquia._id)
        }
      }
    }
    /* 'digitos': function (val) {
      if (val.length > 7) {
        console.log('entro')
        this.digitos = this.digitos.slice(0, 7)
        console.log(this.digitos)
      }
    } */
  },
  created () {
    this.config = this.$store.state.config.clientes
    this.initialize()
    this.permisosCli = this.$store.state.empresa[0].permisos.find(
      permiso => permiso.ruta === 'TipoCliente'
    )
  },
  methods: {
    validarCrearCli () {
      return this.permisosCli?.accion?.includes('Crear')
    },

    agregarMarker (obj) {
      if (!this.read) {
        this.marker.position = obj.latLng
        this.form.lat = this.marker.position.lat()
        this.form.lng = this.marker.position.lng()
      }
    },
    changeEstado (data) {
      const es = this.estado.find(es => es._id === data)
      this.form.codEstado = es
      this.selecEstado = this.form.codEstado._id
      this.arrayMunicipioEstado = []
      for (let i = 0; i < this.idMunicipioArray.length; i++) {
        if (data === this.idMunicipioArray[i].codEstado._id) {
          this.arrayMunicipioEstado.push(this.idMunicipioArray[i])
        }
      }
    },
    changeMunicipio (data) {
      const mu = this.municipio.find(mu => mu._id === data)
      this.form.codMunicipio = mu
      this.selecMunicipio = this.form.codMunicipio._id
      this.arrayParroquiaMunicipio = []
      for (let i = 0; i < this.idParroquiaArray.length; i++) {
        if (data === this.idParroquiaArray[i].codMunicipio._id) {
          this.arrayParroquiaMunicipio.push(this.idParroquiaArray[i])
        }
      }
    },
    changeParroquia (data) {
      const pa = this.parroquia.find(pa => pa._id === data)
      this.form.codParroquia = pa
    },
    changeRuta (data) {
      const rutaselec = this.ruta.find(rutaselec => rutaselec._id === data)
      this.form.idRuta = rutaselec._id
    },
    concatenarRif () {
      this.form.rif = this.rifLetra + '-' + this.rifNumerico
    },
    desconcatenarRif (rif) {
      this.rifLetra = rif.charAt(0)
      this.rifNumerico = rif.substr(2)
    },

    concatenarNum () {
      this.form.telefono = this.numCodigoCli + '-' + this.digitos
    },
    desconcatenarNum (telf) {
      this.numCodigoCli = telf.substr(0, 4)
      this.digitos = telf.substr(5)
    },

    initialize () {
      this.listarEstado()
      this.listarMunicipio()
      this.listarParroquia()
      this.listarTipo()
      this.listarRuta()
    },
    listarTipo () {
      Api.get('/tipoCliente')
        .then(response => {
          this.tipo = response.data
          this.tipo.map(data => {
            this.idTipoArray.push({
              text: data.descripcion,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    listarRuta () {
      Api.get('/ruta')
        .then(response => {
          this.ruta = response.data
          this.ruta.map(data => {
            this.idRutaArray.push({
              text: data.descripcion,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    listarEstado () {
      Api.get('/estado')
        .then(response => {
          this.estado = response.data
          this.estado.map(data => {
            this.idEstadoArray.push({
              text: data.nombre,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    listarMunicipio () {
      Api.get('/municipio')
        .then(response => {
          this.municipio = response.data
          this.municipio.map(data => {
            this.idMunicipioArray.push({
              text: data.nombre,
              value: data._id,
              codEstado: data.codEstado
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    listarParroquia () {
      Api.get('/parroquia')
        .then(response => {
          this.parroquia = response.data
          this.parroquia.map(data => {
            this.idParroquiaArray.push({
              text: data.nombre,
              value: data._id,
              codMunicipio: data.codMunicipio
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },
    validarLimite () {
      if (
        this.config.campoLimCreditoCli &&
        this.config.campoLimCreditoCli.valor
      ) {
        if (
          this.form.limiteCredito === '' ||
          this.form.limiteCredito <= 0 ||
          this.form.limiteCredito === null
        ) {
          return true
        }
      }
      return false
    },

    validarDias () {
      if (
        this.config.campoDiasCreditoCli &&
        this.config.campoDiasCreditoCli.valor
      ) {
        if (
          this.form.diasCredito === '' ||
          this.form.diasCredito <= 0 ||
          this.form.diasCredito === null
        ) {
          return true
        }
      }
      return false
    },

    validarCorreo (correo) {
      const validate = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!validate.test(correo)) {
        return true
      }
      return false
    },
    validarSteps () {
      switch (this.e6) {
        case 1:
          if (this.read && this.editedIndex > -1) {
            this.e6 = 2
            break
          }
          if (
            this.form.nombre === '' ||
            this.rifLetra === '' ||
            this.rifNumerico === '' ||
            this.numCodigoCli === '' ||
            this.digitos === '' /* ||
            !this.marker.position */
          ) {
            this.$swal({
              icon: 'error',
              title: 'Formulario incompleto!',
              text: 'Por favor llene todos los campos para continuar'
            })
            // } else if (this.form.nombre.length > 30) {
            //   this.$swal({
            //     icon: "error",
            //     title: "Nombre invalido!",
            //     text:
            //       "Ha excedido el limite de caracteres para el nombre comercial"
            //   });
          } else if (this.rifNumerico.length < 7) {
            this.$swal({
              icon: 'error',
              title: 'Rif invalido!',
              text: 'El rif debe tener entre 7 a 9 caracteres'
            })
          } else if (this.digitos.length !== 7) {
            this.$swal({
              icon: 'error',
              title: 'Telefono invalido!',
              text: 'El teléfono debe tener 7 caracteres'
            })
          } else if (
            this.validarCorreo(this.form.correo) &&
            this.form.correo !== ''
          ) {
            this.$swal({
              icon: 'error',
              title: 'Correo invalido!',
              text: 'El correo ingresado no cumple con el debido formato'
            })
          } else if (this.validarLimite()) {
            this.$swal({
              icon: 'error',
              title: 'Dato Invalido, el Credito debe ser mayor a 0',
              text: 'Porfavor verifique el campo e intente de nuevo.'
            })
          } else if (this.validarDias()) {
            this.$swal({
              icon: 'error',
              title: 'Dato Invalido, los días de Credito debe ser mayor a 0',
              text: 'Porfavor verifique el campo e intente de nuevo.'
            })
          } else if (
            this.enabled &&
            (this.form.codigoSunagro === '' ||
              this.form.codigoSunagro.length !== 6)
          ) {
            this.$swal({
              icon: 'error',
              title: 'Codigo invalido!',
              text: 'El codigo sunagro debe ser de 6 digitos numéricos'
            })
          } else {
            this.concatenarRif()
            this.concatenarNum()
            this.e6 = 2
          }
          break
        case 2:
          this.save()
          break
      }
    },
    noRequerido (data) {
      Object.keys(data).forEach(function (key) {
        if (data[key] === '') delete data[key]
      })
    },
    formDefault (form, form2) {
      Object.keys(form).forEach(function (key) {
        Object.keys(form2).forEach(function (key2) {
          if (key === key2) {
            form2[key2] = form[key]
          }
        })
      })
      form2._id = form._id
      form2.idEmpresa = form.idEmpresa
      if (form2.lat && form2.lng) {
        this.marker.position = { lat: form2.lat, lng: form2.lng }
      }
    },
    close () {
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultItem)
        this.e6 = 1
        this.rifNumerico = ''
        this.rifLetra = 'V'
        this.form.rif = ''
        this.digitos = ''
        this.numCodigoCli = '0424'
        this.form.telefono = ''
        this.selecEstado = ''
        this.selecMunicipio = ''
        this.form.codParroquia = ''
        this.marker.position = null
      }, 300)
      this.$emit('close')
    },
    save () {
      this.noRequerido(this.form)
      this.$swal({
        title: 'Cargando...',
        html: 'Esperando respuesta del servidor',
        allowOutsideClick: false,
        onBeforeOpen: () => {
          this.$swal.showLoading()
        }
      })
      if (this.editedIndex > -1) {
        Api.put('/cliente', this.form)
          .then(res => {
            if (res.data.status === 'denied') {
              this.$swal({
                icon: 'error',
                title: 'Error al guardar',
                text: res.data.message
              })
            } else {
              this.$emit('edited', this.form)
              this.$swal({
                icon: 'success',
                title: 'Modificacion exitosa',
                text: 'Todos los cambios han sido efectuados'
              })
              this.close()
            }
          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al modificar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message)
            }
          })
      } else {
        Api.post('/cliente', this.form)
          .then(res => {
            if (res.data.status === 'denied') {
              this.$swal({
                icon: 'error',
                title: 'Error al guardar',
                text: res.data.message
              })
            } else {
              this.$emit('save', this.form)
              this.$swal({
                icon: 'success',
                title: 'Inclusion exitosa',
                text: 'Todos los datos han sido guardados'
              })
              this.close()
            }
          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al guardar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message)
            }
          })
      }
    }
  }
}
</script>
